import React from "react";
import styled from "styled-components";
import { RegistrationForm } from "../components/Auth/RegistrationForm";
import { Link } from "react-router-dom";
import { Button } from "../components/Button/Button";

export const Registration = () => {
	return (
		<StyledComponent>
			<RegistrationForm />
			<Link to="/">
				<Button type="button" className="regBtn">
					Назад
				</Button>
			</Link>
		</StyledComponent>
	);
};

const StyledComponent = styled.div`
	width: 200px;
	padding: 1rem;
	margin: auto;
	padding-top: 15%;

	display: flex;
	flex-direction: column;
	gap: 0.5rem;

	& form {
		display: flex;
		flex-direction: column;
		gap: 0.5rem;
	}

	& .regBtn {
		width: 100%;
	}
`;
